(() => {
  const canvas = document.getElementById('fireworksCanvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let w, h;

  function resize() {
    w = canvas.width = window.innerWidth;
    h = canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  const fireworks = [];
  const particles = [];
  const gravity = 0.06;
  const friction = 0.98;

  class Firework {
    constructor() {
      this.x = Math.random() * w;
      this.y = h;
      this.targetY = Math.random() * h * 0.5 + h * 0.1;
      this.speed = Math.random() * 3 + 4;
      this.angle = -Math.PI / 2;
      this.hue = Math.random() * 360;
      this.brightness = Math.random() * 20 + 50;
    }
    update() {
      this.y += Math.sin(this.angle) * this.speed;
      if (this.y <= this.targetY) {
        this.explode();
        return true;
      }
      this.draw();
      return false;
    }
    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, 2, 0, Math.PI * 2);
      ctx.fillStyle = `hsl(${this.hue},100%,${this.brightness}%)`;
      ctx.fill();
    }
    explode() {
      const count = 80 + Math.random() * 40;
      for (let i = 0; i < count; i++) {
        particles.push(new Particle(this.x, this.y, this.hue));
      }
    }
  }

  class Particle {
    constructor(x, y, hue) {
      this.x = x;
      this.y = y;
      this.angle = Math.random() * Math.PI * 2;
      this.speed = Math.random() * 6 + 2;
      this.friction = friction;
      this.gravity = gravity;
      this.hue = hue;
      this.alpha = 1;
      this.decay = Math.random() * 0.015 + 0.01;
    }
    update() {
      this.speed *= this.friction;
      this.x += Math.cos(this.angle) * this.speed;
      this.y += Math.sin(this.angle) * this.speed + this.gravity;
      this.alpha -= this.decay;
      this.draw();
      return this.alpha <= 0;
    }
    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, 1.5, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(${this.hue},100%,60%,${this.alpha})`;
      ctx.fill();
    }
  }

  function loop() {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'lighter';

    if (Math.random() < 0.05) fireworks.push(new Firework());

    for (let i = fireworks.length - 1; i >= 0; i--) {
      if (fireworks[i].update()) fireworks.splice(i, 1);
    }

    for (let i = particles.length - 1; i >= 0; i--) {
      if (particles[i].update()) particles.splice(i, 1);
    }

    requestAnimationFrame(loop);
  }

  loop();
})();
